import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { X } from "react-feather";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  open,
  onClose,
  title,
  description,
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {title}
          {/* <X size={32} color="#FF5722" style={{ cursor: "pointer" }} onClick={handleClose} /> */}
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};
